import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import Box from "@mui/material/Box";
const useStyles = makeStyles(() => ({
    spacer: {
        visibility: "hidden",
    },
    root: {
        boxShadow: "0px -3px 6px #00000029",
        backgroundColor: "white",
        position: "fixed",
        bottom: 0,
        left: 0,
        width: "100%",
    },
}));
const BottomBar = ({ children }) => {
    const classes = useStyles();
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, { className: classes.spacer }, children),
        React.createElement(Box, { className: classes.root }, children)));
};
export default BottomBar;
